// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"445":"0d9c249a","454":"4892e723","501":"ed1c4e58","594":"1a30a0da"}[chunkId] + ".css";
};